import { render, staticRenderFns } from "./CustomerManagementReport.vue?vue&type=template&id=07560272&scoped=true&"
import script from "./CustomerManagementReport.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagementReport.vue?vue&type=style&index=0&id=07560272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07560272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VPagination,VRow,VSelect,VSimpleTable,VTextField})
